import { useState } from 'react';
import { wixLogout } from './logout';

// Drives a "Signing out…" state on logout buttons. The signout redirect is a
// cross-origin navigation that takes a beat to begin before the page swaps, so
// we flip the flag and hand off on the next frame — that lets the button
// repaint as pending instead of looking dead during the wait.
export function useLogout(): { loggingOut: boolean; logout: () => void } {
  const [loggingOut, setLoggingOut] = useState(false);
  const logout = () => {
    if (loggingOut) return;
    setLoggingOut(true);
    requestAnimationFrame(() => wixLogout());
  };
  return { loggingOut, logout };
}
